'use client';

import { ErrorTemplate } from '~/app/_components/ErrorTemplate';
import { pagesPath } from '~/libs/$path';

export default function NotFound() {
  return (
    <ErrorTemplate
      title='404: ページが見つかりません'
      description='お探しのページは存在しないか、移動した可能性があります。'
      links={[
        { label: 'ホームへ戻る', url: pagesPath.$url().path },
        { label: 'お問い合わせ', url: pagesPath.contact.$url().path },
      ]}
    />
  );
}
